import {
  PipelineCardDetailsI,
  PipelineCardI,
} from "@/api/routes/manage-pipeline";
import { WIDGETS_SEARCH_QUERY_PARAM_NAMES } from "@/components/shared/widgets/constants";
import Router from "@/helpers/router";

/**
 * Where a meeting opens (C-16 S3). The Recovery Queue and a reminder bell
 * open the dialer on the contact, inside the priority list of whoever holds
 * the account (the owner, else the booker: no-shows and cancels, then booked
 * meetings, then feedback received), the link Command Center's sheet built.
 * Upcoming opens the meeting in the customer app's Account Details, where an
 * LGA records its outcome.
 */
export const getDialerHrefFor = ({
  campaignId,
  accountId,
  contactId,
  listId,
}: {
  campaignId: string;
  accountId: string;
  contactId: string;
  listId?: string;
}): string => {
  const contact = new URLSearchParams({
    [WIDGETS_SEARCH_QUERY_PARAM_NAMES.CONTACT_ID]: contactId,
  });
  const widget = `${Router.searchQueryParams.accountDetails(campaignId, accountId)}&${contact.toString()}`;
  const list = listId ? Router.lists(listId) : Router.lists();

  return `${list}${list.includes("?") ? "&" : "?"}${widget}`;
};

export const getDialerHref = (
  card: PipelineCardI,
  details: PipelineCardDetailsI | undefined
): string =>
  getDialerHrefFor({
    campaignId: card.campaign_id,
    accountId: card.account_id,
    contactId: card.contact_id,
    listId: details?.list_id,
  });

export const getCustomerHref = (card: PipelineCardI): string =>
  Router.customerAccountDetails(card.campaign_id, card.account_id);
